import {
    BOT_DETAILS,
    FRODOBOT_ID,
    STATUS_DETAILS,
    ALL_BOT,
    CLEAR_REDUX,
    BOT_AVAILABILITY
} from '../actionTypes';

const initialState = {
    botDetails: "",
    botAvailability: undefined,
    frodobotId: "frodobot_609849",
    statusDetails: {
        checked: "",
        default: true
    },
    allBot: {}
}

export const botDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case BOT_DETAILS:
            return {
                ...state,
                botDetails: action.payload
            };
        case BOT_AVAILABILITY:
            return {
                ...state,
                botAvailability: action.payload
            }
        case FRODOBOT_ID:
            return {
                ...state,
                frodobotId: action.payload
            };
        case STATUS_DETAILS:
            return {
                ...state,
                statusDetails: action.payload
            };
        case ALL_BOT:
            return {
                ...state,
                allBot: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}